import React from 'react'
import FilterColumn from './components/FilterColumn'
import moment from "moment";

const normalizeString = (value) => {
  return value.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();
}

const filterTextMethod = (rows, columnId, filterValue) => {
  const normalizedFilterValue = normalizeString(filterValue)
  const rowsFiltered = rows.filter(
    row => normalizeString(row.values[columnId]).includes(normalizedFilterValue)
  )
  return filterValue !== "" ? rowsFiltered : rows
}

const filterNumberMethod = (rows, columnId, filterValue) => {
  const rowsFiltered = rows.filter(row => row.values[columnId] == filterValue)
  return filterValue !== "" ? rowsFiltered : rows
}

const footerGetTotal = ({filteredRows, column}) => {
  const { id, numberDecimal, showSpaceForThousand } = column
  const total = filteredRows.reduce((sum, row) => row.values[id] + sum, 0)
  if(showSpaceForThousand && typeof total === 'number')
    return total.toLocaleString("fr", {
      minimumFractionDigits: numberDecimal,
      maximumFractionDigits: numberDecimal
    })
  else {
    if(total && typeof total === 'number')
      return total.toFixed(numberDecimal)
    return total
  }
    
}

const FilterColumnText = ({column}) => {
  return <FilterColumn inputType="text" column={column}/>
}

const FilterColumnNumber = ({column}) => {
  return <FilterColumn inputType="number" column={column}/>
}

export const getColumnType = (type) => {
  switch(type) {
    case "Timestamp":
    case "Date":
    case "DateTime":
      return "date"
    case "Integer":
    case "Number":
      return "number"
    case "String":
    default:
      return "text"
  }
}

export const getReactTableColumns = (columnsLabelsMapping = [], reactColumnOptions) => {
  const { 
    enableFilters, 
    enableFooters, 
    showSpaceForThousand, 
    numberDecimal, 
    freezeFirstColumn,
  } = reactColumnOptions
  
  const columns = []

  columnsLabelsMapping.forEach(labelUuidMapping => {
    const { 
      type, 
      label, 
      valueId,
      displayPercentSymbolAfterValue 
    } = labelUuidMapping

    const columnType = getColumnType(type)
    let column = {
      Header: label,
      accessor: valueId,
      type: columnType,
      numberDecimal: numberDecimal,
      showSpaceForThousand: showSpaceForThousand,
    }
    if(enableFilters){
      switch(columnType) {
        case "number":
          column.Filter = FilterColumnNumber
          column.filter = filterNumberMethod
          break
        case "text":
          column.Filter = FilterColumnText
          column.filter = filterTextMethod
          break
        default:
          column.disableFilters = true
          break
      }
    }
    if(enableFooters){
      switch(columnType) {
        case "number":
          column.Footer = footerGetTotal
          break
        default:
          column.Footer = ""
          break
      }
    }
    if(columnType === "date"){
      column.Cell = ({ value }) => {
        if(moment(value, "x", true).isValid() && !moment(value, "YYYY", true).isValid()) return moment(value, 'x').format('DD/MM/YYYY')
        else if(moment(value, "YYYY-MM-DD", true).isValid()) return moment(value, 'YYYY-MM-DD').format('DD/MM/YYYY')
        else if(moment(value, "YYYY-MM", true).isValid()) return moment(value, 'YYYY-MM').format('MM/YYYY')
        else if(moment(value, "YYYY", true).isValid()) return moment(value, 'YYYY').format('YYYY')
        else return value
      }
    } else if(columnType === 'number'){
      column.Cell = ({ value }) => {
        if([undefined, null].includes(value)) return value
        if(typeof value !== 'number') return value
        
        var valueToReturn = value
        if(showSpaceForThousand) {
          valueToReturn = value.toLocaleString("fr", {
            minimumFractionDigits: numberDecimal,
            maximumFractionDigits: numberDecimal
          })
        } else valueToReturn = value.toFixed(numberDecimal)

        if(displayPercentSymbolAfterValue) {
          valueToReturn = `${valueToReturn}%`
        }   

        return valueToReturn
      }
    } else if(columnType === 'text' && displayPercentSymbolAfterValue){
      column.Cell = ({ value }) => {
        if([undefined, null].includes(value)) return value
        return  `${value}%`
      }
    }

    if(freezeFirstColumn && columns.length === 0) column["sticky"] = "left"
    
    columns.push(column)
  })
  return columns
}